import * as actionTypes from "../constants/actionTypes";

const initialState = {
    keyboardState: false,
    selector: null,
    text: ""
};

/**
 * Structure of object from virtualKeyboard store:
 * - keyboardState {Boolean}    - if true, keyboard is opened
 * - selector {String}          - input identificator
 * - text {String}              - keyboard input value
 */
export const virtualKeyboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_KEYBOARD_STATE:
            return {
                keyboardState: action.payload.state,
                selector: null,
                text: ""
            };
        case actionTypes.SAVE_UNIVERSAL_KEYBOARD_STATE:
            return {
                keyboardState: action.payload.state,
                selector: action.payload.selector,
                text: ""
            };
        case actionTypes.SET_KEYBOARD_TEXT:
            return {
                ...state,
                text: action.payload.text
            };
        case actionTypes.SAVE_NEW_TAB:
        case actionTypes.SAVE_TAB_OR_OPEN_EXISTING_TAB:
        case actionTypes.SET_ACTIVE_TAB:
        case actionTypes.SET_ACTIVE_TAB_SCENE:
        case actionTypes.SET_ACTIVE_TAB_AND_SCENE:
        case actionTypes.OPEN_HOME_TAB:
        case actionTypes.ADD_NEW_MAIN_TAB:
        case actionTypes.MENU_ADD_NEW_OR_OPEN_MAIN_TAB:
        case actionTypes.MENU_ADD_NEW_OR_OPEN_COLOR_PALETTE_TAB:
        case actionTypes.MENU_ADD_NEW_OR_OPEN_COLOR_SEARCH_TAB:
        case actionTypes.MENU_ADD_NEW_OR_OPEN_CUSTOM_TAB:
        case actionTypes.MENU_ADD_NEW_FAVORITES_TAB:
        case actionTypes.MENU_ADD_NEW_CANISTERS_TAB:
        case actionTypes.MENU_ADD_NEW_SPECTRO_TAB:
        case actionTypes.MENU_ADD_NEW_STATISTICS_TAB:
        case actionTypes.MENU_ADD_NEW_CUSTOMERS_TAB:
        case actionTypes.MENU_ADD_NEW_MY_ORDERS_TAB:
        case actionTypes.MENU_ADD_NEW_TO_DISPENSE_TAB:
        case actionTypes.MENU_ADD_NEW_BUG_REPORT_TAB:
        case actionTypes.MENU_ADD_NEW_ORDERS_HISTORY_TAB:
        case actionTypes.MENU_ADD_NEW_GLOBAL_SEARCH_TAB:
        case actionTypes.CLONE_MAIN_TO_CUSTOM_TAB:
        case actionTypes.CLONE_MATCHING_TO_CUSTOM_TAB:
        case actionTypes.CLONE_HISTORY_TO_CUSTOM_TAB:
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS:
            if (state.keyboardState) {
                return {
                    keyboardState: false,
                    selector: null,
                    text: ""
                };
            }

            return state;
        case actionTypes.WEBSOCKET_CLOSED:
            return initialState;
        default:
            return state;
    }
};
